module.exports = __webpack_public_path__ + "img/hero-img.1b058103.png";